import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counselling-report-dashboard',
  templateUrl: './counselling-report-dashboard.component.html',
  styleUrls: ['./counselling-report-dashboard.component.scss']
})
export class CounsellingReportDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
